// import $ from "jquery";
import baseClass from "./base";
import "./jquery.crypt";

// ------------------------------------
function jssugestion_getselectedclass(obj) {
  var selclass = "selected";
  var sclass = obj.attr("data-selclass");

  if (sclass != undefined && sclass) selclass = sclass;
  return selclass;
}

// ------------------------------------
function jssugestion_submit(obj) {
  var sf = obj.attr("data-sf");
  if (sf != undefined && sf) {
    $(sf).submit();
    baseClass.ShowIsLoadingInProgress();
    jssugestion_clear(obj);
  }
}

// ------------------------------------
function jssugestion_each(obj) {
  if (obj.hasClass("true")) return;

  obj.addClass("true");

  obj.attr("autocomplete", "OFF");

  var mainid = obj.attr("data-mainid");
  if (mainid == undefined) {
    mainid = obj.attr("id");
    obj.attr("data-mainid", mainid);
  }

  var minlen = obj.attr("data-minlen");
  minlen = parseInt(minlen);
  if (minlen == undefined || isNaN(minlen) || !minlen) minlen = 3;
  obj.attr("data-minlen", minlen);

  var loadIndicator = obj.attr("loadIndicator");
  if (loadIndicator == undefined) {
    obj.attr("loadIndicator", "0");
  }

  var putloadinindicator = obj.attr("putloadinindicator");
  if (putloadinindicator == undefined) {
    obj.attr("putloadinindicator", "1");
  }
}

// ------------------------------------
function jssugestion_sethash(obj) {
  var v = obj.val();
  var hash = !v ? "" : $().crypt({ method: "md5", source: v });
  obj.attr("data-hash", hash);
}

// ------------------------------------
function jssugestion_clear(obj) {
  var targetid = obj.attr("data-targetid");

  if (targetid == undefined) return;
  $("#" + targetid).html("");
}

// ------------------------------------
function jssugestion_buildurl(obj) {
  var url = obj.attr("data-url");

  if (url.indexOf("?") >= 0) url += "&rt=json";
  else url += "?rt=json";

  var valids = obj.attr("data-valids");
  if (valids == undefined) valids = "";
  url += "&valids=" + valids;

  var htmlids = obj.attr("data-htmlids");
  if (htmlids == undefined) htmlids = "";
  url += "&htmlids=" + htmlids;

  var mainid = obj.attr("data-mainid");
  if (mainid == undefined) mainid = "";
  url += "&mainid=" + mainid;

  var selectids = obj.attr("data-selectids");
  if (selectids == undefined) selectids = "";
  url += "&selectids=" + selectids;

  var checkids = obj.attr("data-checkids");
  if (checkids == undefined) checkids = "";
  url += "&checkids=" + checkids;

  url += jssugestion_buildurlotherinfo(obj);

  url += "&hash=" + obj.attr("data-hash");

  return url;
}

// ------------------------------------
function jssugestion_buildurlotherinfo(obj) {
  var url = "";

  var otherinfo = obj.attr("data-otherinfo");

  if (otherinfo == undefined || !otherinfo) return url;

  // otherinfo strunture:
  // 			block1||block2||...||blockN
  // 		block:
  // 			getName|TYPE|selector
  // 		TYPE:
  // 			val - input text, checkbox, radio, ...
  //			select - selector is only select (NOT option)
  //			html - html();

  var t1 = otherinfo.split("||");

  for (var i in t1) {
    var block = t1[i];
    if (!block) continue;
    var t2 = block.split("|");
    if (t2.length != 3) continue;

    var value = "";
    var tobj = $(t2[2]);

    if (t2[1] == "val") value = tobj.val();
    else if (t2[1] == "select") value = tobj.find("option:selected").val();
    else if (t2[1] == "html") value = tobj.html();
    url += "&" + t2[0] + "=";
    url += value && value != undefined ? encodeURIComponent(value) : "";
  }

  return url;
}

function jssugestion_clearbeforerequest(obj) {
  // -------------
  var clearval = obj.attr("clearval");
  if (clearval != undefined && clearval) {
    var tid = clearval.split("|");
    for (var i in tid) {
      $(tid[i]).val("");
    }
  }
  // -------------

  // -------------
  var clearhtml = obj.attr("clearhtml");

  if (clearhtml != undefined && clearhtml) {
    var tid = clearhtml.split("|");
    for (var i in tid) {
      $(tid[i]).html("");
    }
  }
  // -------------
}

// ------------------------------------
function jssugestion_sendrequest(obj) {
  jssugestion_clearbeforerequest(obj);
  var minlen = parseInt(obj.attr("data-minlen"));
  var strl = parseInt(obj.val().length);

  if (strl < minlen) {
    jssugestion_clear(obj);
    return;
  }

  var targetid = obj.attr("data-targetid");
  if (targetid == undefined) return;

  // ------------------
  var loadIndicator = obj.attr("loadIndicator");
  if (loadIndicator != undefined && parseInt(loadIndicator))
    baseClass.ShowIsLoadingInProgress();
  var putloadinindicator = obj.attr("putloadinindicator");
  if (putloadinindicator != undefined && parseInt(putloadinindicator))
    baseClass.putloadinindicator(targetid);
  // ------------------

  var info = {};
  info.url = jssugestion_buildurl(obj);
  info.type = "ajaxHTML";
  info.targetid = targetid;

  var jwt = $("meta[name='jwt']").attr("content");

  $.ajax(
    {
      url: info.url,
      cache: false,
      dataType: "json",
      type: "GET",
      headers: {
        Authorization: "Bearer " + jwt,
      },
      success: function (data, status, xhr) {
        jssugestion_successload(obj, data, info, status, xhr);
        return;
      },
      error: function (data, status, xhr) {
        jssugestion_errorload(obj, data, info, status, xhr);
        return;
      },
    },
    1
  );
}

// ------------------------------------
function jssugestion_successload(obj, data, info, status, xhr) {
  var targetid = obj.attr("data-targetid");

  if (data.hash == undefined || !data.hash)
    return jssugestion_errorload(obj, data);

  var realhash = obj.attr("data-hash");
  if (realhash != data.hash) return jssugestion_errorload(obj, data);

  //   if (data.HTML != undefined) $("#" + targetid).html(data.HTML);

  // console.log("jssugestion_successloadjssugestion_successload");
  // baseClass.OnReadyEventsAll(data, true, targetid, false);
  baseClass.processAjaxResultSuccess(data.HTML, info, status, xhr);
  //   baseClass.OnReadyEventsAll();
  //   baseClass.HideIsLoadingInProgress();
  return;
}

// ------------------------------------
function jssugestion_errorload(obj, data, info, status, xhr) {
  baseClass.processAjaxResultError(data, info, status, xhr);
  //   baseClass.HideIsLoadingInProgress();
  return;
}

// ------------------------------------
function jssugestion_getselecteditem(obj) {
  var selclass = jssugestion_getselectedclass(obj);

  var targetid = obj.attr("data-targetid");
  if (targetid == undefined) return false;
  var selecteditem = $("#" + targetid).find(".js_sugestion_item." + selclass)
    .length
    ? $("#" + targetid).find(".js_sugestion_item." + selclass)
    : false;
  // console.log("jssugestion11111", selecteditem);
  return selecteditem;
}

// ------------------------------------
function jssugestion_selectitem(obj, itemobj) {
  var selclass = jssugestion_getselectedclass(obj);
  var targetid = obj.attr("data-targetid");
  if (targetid == undefined) return false;
  $("#" + targetid)
    .find(".js_sugestion_item:not(#" + itemobj.attr("id") + ")")
    .removeClass(selclass);
  itemobj.addClass(selclass);
}

// ------------------------------------
function jssugestion_getprevitem(obj, selecteditem) {
  var targetid = obj.attr("data-targetid");
  if (targetid == undefined) return false;

  if (selecteditem == false)
    return $("#" + targetid).find(".js_sugestion_item:last");

  var itemobj = false;
  var isfind = false;
  $("#" + targetid)
    .find(".js_sugestion_item")
    .each(function () {
      if (isfind) return;
      if ($(this).attr("id") == selecteditem.attr("id")) {
        isfind = true;
        return;
      }
      itemobj = $(this);
    });
  if (itemobj == false)
    itemobj = $("#" + targetid).find(".js_sugestion_item:last");
  return itemobj;
}

// ------------------------------------
function jssugestion_getnextitem(obj, selecteditem) {
  var targetid = obj.attr("data-targetid");
  if (targetid == undefined) return false;

  if (selecteditem == false)
    return $("#" + targetid).find(".js_sugestion_item:first");

  var itemobj = false;
  var isfind = false;
  $("#" + targetid)
    .find(".js_sugestion_item")
    .each(function () {
      if (itemobj) return;
      if ($(this).attr("id") == selecteditem.attr("id")) {
        isfind = true;
        return;
      }
      if (isfind) itemobj = $(this);
    });
  if (itemobj == false)
    itemobj = $("#" + targetid).find(".js_sugestion_item:first");
  return itemobj;
}

// ------------------------------------
function jssugestion_selectpreviewitem(obj) {
  var targetid = obj.attr("data-targetid");
  if (targetid == undefined) return;
  if (!$("#" + targetid).find(".js_sugestion_item").length) return;

  var selecteditem = jssugestion_getselecteditem(obj);

  var itemobj = jssugestion_getprevitem(obj, selecteditem);

  jssugestion_selectitem(obj, itemobj);
}

// ------------------------------------
function jssugestion_selectnextitem(obj) {
  var targetid = obj.attr("data-targetid");
  if (targetid == undefined) return;
  if (!$("#" + targetid).find(".js_sugestion_item").length) return;

  var selecteditem = jssugestion_getselecteditem(obj);

  var itemobj = jssugestion_getnextitem(obj, selecteditem);

  jssugestion_selectitem(obj, itemobj);
}

// ------------------------------------
function jssugestion_useselecteditem(obj) {
  // 	console.log(
  //     "jssugestion11111",
  //     "jssugestion_useselecteditemjssugestion_useselecteditem",
  //     obj
  //   );
  var selecteditem = jssugestion_getselecteditem(obj);

  var canemptysubmit = selecteditem.attr("data-canemptysubmit");

  if (selecteditem == false) {
    if (canemptysubmit != undefined && canemptysubmit == "1") {
      jssugestion_clearbeforerequest(obj);
      jssugestion_submit(obj);
    }
    return;
  }

  var valids = selecteditem.attr("data-valids");
  var htmlids = selecteditem.attr("data-htmlids");
  var selectids = selecteditem.attr("data-selectids");
  var checkids = selecteditem.attr("data-checkids");
  var valvalues = selecteditem.attr("data-valvalues");
  var htmlvalues = selecteditem.attr("data-htmlvalues");
  var selectvalues = selecteditem.attr("data-selectvalues");
  var checkvalues = selecteditem.attr("data-checkvalues");
  var url = selecteditem.attr("data-url");
  var targetid = selecteditem.attr("data-targetid");
	var ajaxtype = selecteditem.attr("data-ajaxtype");
	ajaxtype = ajaxtype == undefined ? "ajaxHTML" : ajaxtype;

  // console.log(
  //   "jssugestion11111",
  //   "jssugestion_useselecteditemjssugestion_useselecteditem",
  //   obj,
  //   selecteditem
  // );

  if (valids != undefined && valids) {
    var tid = valids.split("|");
    var tval = valvalues.split("|");

    for (var i in tid) {
      var oid = tid[i];
      var oval = tval[i];
      if (oid != undefined && oval != undefined) {
        $("#" + oid).val(oval);
      }
    }
  }

  if (htmlids != undefined && htmlids) {
    var tid = htmlids.split("|");
    var tval = htmlvalues.split("|");
    for (var i in tid) {
      var oid = tid[i];
      var oval = tval[i];
      if (oid != undefined && oval != undefined) {
        $("#" + oid).html(oval);
      }
    }
  }

  if (selectids != undefined && selectids) {
    var tid = selectids.split("|");
    var tval = selectvalues.split("|");
    for (var i in tid) {
      var oid = tid[i];
      var oval = tval[i];
      if (oid != undefined && oval != undefined) {
        $("#" + oid + " option").each(function () {
          if ($(this).val() == oval) {
            $(this).attr("selected", "selected");
            $(this).prop("selected", true);
          } else {
            $(this).removeAttr("selected");
            $(this).prop("selected", false);
          }
        });
        $("#" + oid + " option").change();
      }
    }
  }

  if (checkids != undefined && checkids) {
    // alert(checkids + "\n" + checkvalues);
    var tid = checkids.split("|");
    var tval = checkvalues.split("|");
    for (var i in tid) {
      var oid = tid[i];
      var oval = tval[i];
      // alert('oid = ' + oid + "\n" + 'oval = ' + oval );
      if (oid != undefined && oval != undefined) {
        var t = parseInt(oval);
        if (!isNaN(t)) oval = t;
        // alert(oval);
        if (oval) {
          // console.log('check - #' + oid + "\n" + 'oval = ' + oval);
          $("#" + oid).each(function () {
            $(this).attr("checked", true);
            $(this).prop("checked", true);
            $(this).change();
          });
        } else {
          // console.log('uncheck - #' + oid + "\n" + 'oval = ' + oval);
          $("#" + oid).each(function () {
            $(this).prop("checked", false);
            // $(this).attr('checked', false);

            $(this).removeAttr("checked");
            $(this).change();
          });
        }
      }
    }
  }

  if (url != undefined && url && targetid != undefined && targetid) {
    var allurl = url.split("~~");
    var alltargetid = targetid.split("~~");
    for (var i in allurl) {
      if (allurl[i] == undefined || !allurl[i]) continue;
      if (alltargetid[i] == undefined || !alltargetid[i]) continue;

      var info = {};
      info.url = allurl[i];
      info.type = ajaxtype;
      info.targetid = alltargetid[i];

      // baseClass.loadDataAjax($(this));
      baseClass.getAjaxHTML(info);
      // baseClass.getAjaxHTML(allurl[i], alltargetid[i], false);
    }
  }

  jssugestion_clear(obj);
  jssugestion_submit(obj);
}

baseClass.OnReadyArrAdd(function () {
  $(".js_sugestion").each(function (e) {
    // console.log("jssugestion11111", "Button clicked! finded");

    var obj = $(this);

    jssugestion_each(obj);
  });

  $(".js_sugestion")
    .off("keydown")
    .on('keydown', function (e) {
      var obj = $(this);
      // console.log("jssugestion11111", "Button clicked!");
      if (e.keyCode == 13) {
        // Enter
        jssugestion_useselecteditem(obj);
        return false;
      }
      if (e.keyCode == 38) {
        // UP
        jssugestion_selectpreviewitem(obj);
        return false;
      }
      if (e.keyCode == 40) {
        // DOWN
        jssugestion_selectnextitem(obj);
        return false;
      }
    });

  $(".js_sugestion")
    .off("blur")
    .on('blur', function () {
      var obj = $(this);
      jssugestion_clear(obj);
    });

  $(".js_sugestion")
    .off("focus")
    .on('focus', function () {
      var obj = $(this);
      jssugestion_sendrequest(obj);
    });

  $(".js_sugestion")
    .off("keyup")
    .on('keyup', function (e) {
      var obj = $(this);
      jssugestion_sethash(obj);
      if (e.keyCode == 27) {
        // ESC
        jssugestion_clear(obj);
        return;
      }
      if (
        (e.keyCode >= 33 && e.keyCode <= 40) ||
        (e.keyCode >= 112 && e.keyCode <= 123) ||
        e.keyCode == 45 ||
        (e.keyCode >= 16 && e.keyCode <= 18) ||
        e.keyCode == 20 ||
        e.keyCode == 13
      ) {
        // PageUp PageDown End Home LEFT UP RIGHT DOWN
        // F1 - F12
        // Insert
        // Shift Control Alt
        // CapsLock
        // Enter
        return;
      }
      jssugestion_sendrequest(obj);
    });

  $(".js_sugestion_item").each(function () {
    // console.log("jssugestion11111", "js_sugestion_item each");
    // var itemobj = $(this);
    // var mainid = itemobj.attr('data-mainid');
    // if (mainid == undefined) return;
    // var obj = $('#' + mainid);

    // jssugestion_selectitem(obj, itemobj);
  });

  $(".js_sugestion_item")
    .off("mouseenter")
    .on('mouseenter', function () {
      // console.log("jssugestion11111", "mouseenter");
      var itemobj = $(this);
      var mainid = itemobj.attr("data-mainid");
      if (mainid == undefined) return;
      var obj = $("#" + mainid);

      jssugestion_selectitem(obj, itemobj);
    });

  $(".js_sugestion_item")
    .off("mousedown")
    .on('mousedown', function () {
      // console.log("jssugestion11111", "mousedown");
      var itemobj = $(this);
      var mainid = itemobj.attr("data-mainid");
      if (mainid == undefined) return;
      var obj = $("#" + mainid);
      jssugestion_useselecteditem(obj);
    });
});
